import React from 'react'
import styles from './LinkCard.module.css'

interface LinkCardProps {
  children: React.ReactNode
  icon?: React.ReactNode
}

const LinkCard: React.FC<LinkCardProps> = ({ children, icon }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>{children}</div>
      {icon && <div className={styles.icon}>{icon}</div>}
    </div>
  )
}

export default LinkCard
